<div class="flex flex-col gap-3 min-w-80 p-1 pt-3">
  <div class="flex flex-col gap-0.5">
    <span class="ds-body-2-semibold">Adresse des Laufkunden</span>
    <span class="ds-caption text-light">
      @if (customerLabel()) {
        {{ customerLabel() }} — Barverkaufskunde.
      }
      Name, Straße, PLZ und Ort sind für den Beleg erforderlich.
    </span>
  </div>

  <div class="grid grid-cols-2 gap-3">
    <soft-ds-input
      label="Anrede"
      [value]="address().salutation"
      (valueChange)="setField('salutation', $event)"
      data-testid="address-step-salutation"
    />
    <soft-ds-input
      label="Name 1"
      [required]="true"
      [value]="address().name1"
      (valueChange)="setField('name1', $event)"
      data-testid="address-step-name1"
    />
    <soft-ds-input
      label="Name 2"
      [value]="address().name2"
      (valueChange)="setField('name2', $event)"
      data-testid="address-step-name2"
    />
    <soft-ds-input
      label="Name 3"
      [value]="address().name3"
      (valueChange)="setField('name3', $event)"
      data-testid="address-step-name3"
    />
    <soft-ds-input
      class="col-span-2"
      label="Straße"
      [required]="true"
      [value]="address().street"
      (valueChange)="setField('street', $event)"
      data-testid="address-step-street"
    />
    <soft-ds-input
      label="PLZ"
      [required]="true"
      [value]="address().postCode"
      (valueChange)="setField('postCode', $event)"
      data-testid="address-step-postcode"
    />
    <soft-ds-input
      label="Ort"
      [required]="true"
      [value]="address().city"
      (valueChange)="setField('city', $event)"
      data-testid="address-step-city"
    />
    <soft-ds-input
      label="Land"
      [value]="address().countryCode"
      (valueChange)="setField('countryCode', $event)"
      data-testid="address-step-country"
    />
    <soft-ds-input
      label="E-Mail"
      [value]="address().mail1"
      (valueChange)="setField('mail1', $event)"
      (keydown.enter)="confirm()"
      data-testid="address-step-mail"
    />
  </div>
</div>

<ng-template #bottomTpl>
  <div class="flex items-center justify-end w-full mt-2 gap-2 p-1">
    @if (isEmbedded()) {
      <soft-ds-button
        variant="primary"
        size="md"
        [disabled]="!complete()"
        (click)="confirm()"
        data-testid="address-step-next"
      >
        {{ '#SALES.WIZARD.NEXT' | translate }}
      </soft-ds-button>
    }
  </div>
</ng-template>
